import { useEffect, useState } from 'react'
import { RotateCcw, X } from 'lucide-react'
import { docsApi } from '../lib/api'

function formatTime(timestamp) {
  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
}

function formatSize(bytes) {
  if (bytes < 1024) return bytes + ' B'
  return (bytes / 1024).toFixed(1) + ' KB'
}

export default function HistoryModal({ docId = 'projects', onClose, onRestored, notify }) {
  const [loading, setLoading] = useState(true)
  const [rows, setRows] = useState([])
  const [busyVersion, setBusyVersion] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    docsApi.history(docId, 50)
      .then((data) => {
        if (cancelled) return
        setRows(data.history || [])
      })
      .catch((err) => {
        if (cancelled) return
        setError(err.message || '读取历史失败')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => { cancelled = true }
  }, [docId])

  async function restore(version) {
    if (busyVersion !== null) return
    if (!window.confirm('回朔到版本 ' + version + '？当前内容会被替换，但会先自动存一个新的快照，之后仍可再回朔。')) return
    setBusyVersion(version)
    try {
      const result = await docsApi.restore(docId, version)
      const projects = result.payload && Array.isArray(result.payload.projects) ? result.payload.projects : []
      onRestored(projects)
      notify('已回朔到版本 ' + version + '。')
      onClose()
    } catch (err) {
      setError(err.message || '回朔失败')
      setBusyVersion(null)
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="history-modal" onClick={(event) => event.stopPropagation()}>
        <header>
          <div>
            <h3>版本历史</h3>
            <p>每次自动保存都会生成一个快照，最多保留最近 50 个版本。</p>
          </div>
          <button className="icon-button" onClick={onClose} aria-label="关闭"><X size={18} /></button>
        </header>
        <div className="history-list">
          {loading ? <p className="history-empty">正在读取版本记录…</p> : null}
          {!loading && error ? <p className="history-empty">{error}</p> : null}
          {!loading && !error && rows.length === 0 ? <p className="history-empty">还没有版本记录，开始书写后会自动生成。</p> : null}
          {rows.map((row) => (
            <div className="history-row" key={row.version}>
              <span className="history-row__num">v{row.version}</span>
              <div className="history-row__meta">
                <strong>{formatTime(row.updated_at)}</strong>
                <small>{formatSize(row.size)} · 自动保存快照</small>
              </div>
              <button onClick={() => restore(row.version)} disabled={busyVersion !== null}>
                <RotateCcw size={13} /> {busyVersion === row.version ? '回朔中…' : '回朔'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
